import React, { useState } from 'react';
import CompanyInfoCard from './CompanyInfoCard';

export default function SupplierList({ suppliers, setSuppliers, purchaseStats, search, setSearch, message, setMessage }) {
  const [form, setForm] = useState({ id: null, name: '', contact: '', email: '', phone: '', address: '' });
  const [isEditing, setIsEditing] = useState(false);

  const handleSave = (e) => {
    e.preventDefault();
    if (!form.name) return;
    
    let updated;
    if (isEditing) {
      updated = suppliers.map(s => s.id === form.id ? { ...form } : s);
      setMessage('Fournisseur modifié.');
    } else {
      const newId = Date.now().toString();
      updated = [...suppliers, { ...form, id: newId }];
      setMessage('Nouveau fournisseur ajouté.');
    }
    setSuppliers(updated);
    localStorage.setItem('almoune_suppliers', JSON.stringify(updated));
    setForm({ id: null, name: '', contact: '', email: '', phone: '', address: '' });
    setIsEditing(false);
    setTimeout(() => setMessage(''), 3000);
  };

  const handleEdit = (supplier) => {
    setForm({ ...supplier });
    setIsEditing(true);
  };

  const handleDelete = (id) => {
    if (!window.confirm('Supprimer ce fournisseur ?')) return;
    const updated = suppliers.filter(s => s.id !== id);
    setSuppliers(updated);
    localStorage.setItem('almoune_suppliers', JSON.stringify(updated));
    setMessage('Fournisseur supprimé.');
    setTimeout(() => setMessage(''), 3000);
  };

  const filteredSuppliers = suppliers.filter(s => 
    s.name.toLowerCase().includes(search.toLowerCase()) || 
    (s.contact && s.contact.toLowerCase().includes(search.toLowerCase()))
  );

  return (
    <div>
      <CompanyInfoCard />

      <div className="row mb-4">
        <div className="col-md-3">
          <div className="card text-white bg-primary mb-3">
            <div className="card-body">
              <h5 className="card-title">Total Fournisseurs</h5>
              <h3>{suppliers.length}</h3>
            </div>
          </div>
        </div>
      </div>

      <div className="card mb-4 shadow-sm">
        <div className="card-header bg-light">
          <h5 className="mb-0">{isEditing ? 'Modifier Fournisseur' : 'Nouveau Fournisseur'}</h5>
        </div>
        <div className="card-body">
          <form onSubmit={handleSave} className="row g-3">
            <div className="col-md-4">
              <label className="form-label">Nom <span className="text-danger">*</span></label>
              <input type="text" className="form-control" value={form.name} onChange={e => setForm({...form, name: e.target.value})} required />
            </div>
            <div className="col-md-4">
              <label className="form-label">Contact</label>
              <input type="text" className="form-control" value={form.contact} onChange={e => setForm({...form, contact: e.target.value})} />
            </div>
            <div className="col-md-4">
              <label className="form-label">Email</label>
              <input type="email" className="form-control" value={form.email} onChange={e => setForm({...form, email: e.target.value})} />
            </div>
            <div className="col-md-4">
              <label className="form-label">Téléphone</label>
              <input type="tel" className="form-control" value={form.phone} onChange={e => setForm({...form, phone: e.target.value})} />
            </div>
            <div className="col-md-8">
              <label className="form-label">Adresse</label>
              <input type="text" className="form-control" value={form.address} onChange={e => setForm({...form, address: e.target.value})} />
            </div>
            <div className="col-md-6">
              <label className="form-label">SIRET</label>
              <input type="text" className="form-control" value={form.siret || ''} onChange={e => setForm({...form, siret: e.target.value})} />
            </div>
            <div className="col-md-6">
              <label className="form-label">N° TVA</label>
              <input type="text" className="form-control" value={form.tva || ''} onChange={e => setForm({...form, tva: e.target.value})} />
            </div>
            <div className="col-12 text-end">
              {isEditing && (
                <button type="button" className="btn btn-secondary me-2" onClick={() => { setIsEditing(false); setForm({ id: null, name: '', contact: '', email: '', phone: '', address: '', siret: '', tva: '' }); }}>
                  Annuler
                </button>
              )}
              <button type="submit" className="btn btn-primary">{isEditing ? 'Mettre à jour' : 'Ajouter'}</button>
            </div>
          </form>
        </div>
      </div>

      <div className="mb-3">
        <input type="text" className="form-control" placeholder="Rechercher un fournisseur..." value={search} onChange={e => setSearch(e.target.value)} />
      </div>

      <div className="table-responsive">
        <table className="table table-hover align-middle">
          <thead className="table-light">
            <tr>
              <th>Nom</th>
              <th>Contact</th>
              <th>Téléphone</th>
              <th>Email</th>
              <th className="text-end">Actions</th>
            </tr>
          </thead>
          <tbody>
            {filteredSuppliers.map(s => (
              <tr key={s.id}>
                <td><strong>{s.name}</strong></td>
                <td>{s.contact}</td>
                <td>{s.phone}</td>
                <td>{s.email}</td>
                <td className="text-end">
                  <button className="btn btn-sm btn-outline-secondary me-2" onClick={() => handleEdit(s)}>✏️</button>
                  <button className="btn btn-sm btn-outline-danger" onClick={() => handleDelete(s.id)}>🗑️</button>
                </td>
              </tr>
            ))}
            {filteredSuppliers.length === 0 && (
              <tr>
                <td colSpan="5" className="text-center text-muted py-4">Aucun fournisseur trouvé.</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}

